module.exports = __webpack_public_path__ + "img/icos6.df795a74.svg";